import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const handledErrors = [500, 400];

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (handledErrors.includes(error.status)) {
        return throwError(() => error);
      }
      return throwError(() => error);
    })
  );
};
